angular.module('backstage.controllers.theme-editor', [])
    .controller('ThemeAssetsCtrl', require('./themeAssetsCtrl'))
    .controller('ThemeEditorCtrl', require('./themeEditorCtrl'))
    .controller('ThemeImporterCtrl', require('./themeImporterCtrl'))
    .controller('ThemeWizardCtrl', require('./themeWizardCtrl'));
